import PendingAccountList from './PendingAccountList';
import { AdminRouteIds } from './AdminRoutes';
import AdminLayout from './AdminLayout';

export default function Admin() {
    const pageId = AdminRouteIds.adminDashboard;

    return (
        <AdminLayout selectedId={pageId}>
            <PendingAccountList />
        </AdminLayout>
    );
}
